import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import utils from './utils';
import DataTableCell from './DataTableCell';

class DataTableRow extends React.Component {
    constructor(props) {
        super(props);

        this.fieldRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        utils.scrollToQuestion(prevProps.isActive, this.props.isActive, this.fieldRef);
    }

    render() {
        const {
            theme,
            row,
            columns,
            idx,
            onRowClick,
            isActive,
            rowClickable,
        } = this.props;

        const classes = classNames('data-table__row', {
            'data-table__row--active': theme === 'ACTIVE' && rowClickable,
            'data-table__row--active-question': isActive,
        });
        return (
            <tr
                className={classes}
                onClick={event => onRowClick(row, event)}
                ref={this.fieldRef}
            >
                {
                    columns.map((column, index) => {
                        const colKey =
                            utils.getColumnKey(column.accessor, index);

                        return (
                            <DataTableCell
                                {...column}
                                data={row}
                                index={idx}
                                key={colKey}
                            />
                        );
                    })
                }
            </tr>
        );
    }
}

DataTableRow.propTypes = {
    theme: PropTypes.oneOf(['ACTIVE', 'PASSIVE']),
    idx: PropTypes.number,
    row: PropTypes.shape({}),
    columns: PropTypes.arrayOf(PropTypes.shape({})),
    onRowClick: PropTypes.func,
    isActive: PropTypes.bool,
    rowClickable: PropTypes.bool,
};
DataTableRow.defaultProps = {
    theme: 'ACTIVE',
    row: {},
    columns: [],
    idx: 0,
    onRowClick: () => {},
    isActive: false,
    rowClickable: true,
};

export default DataTableRow;
